<template>
  <div class="container-fluid">
    <footer class="footer footer-simple fixed-bottom">
      <div class="container">
        <div class="row">
          <div class="col-4 pt-3 pb-3">
            <a id="btm_1" style="color: white;">© ARCOS {{ year }}</a>
          </div>
          <div class="col-4 pt-3 pb-3">
            <router-link to="/mentionslegales" id="btm_2" style="color: white"
              >Mentions légales</router-link
            >
          </div>
          <div class="col-4 pt-3 pb-3">
            <router-link to="/donneesperso" id="btm_3" style="color: white"
              >Politique DCP</router-link
            >
          </div>
          <!--
          <div class="col-md-6">
            <a class="footer-brand" style="color: white">© ANHOD {{ year }} </a>
          </div>
          <div class="col-md-6">
            <div class="column">
              <ul class="inline-menu">
                <li>
                  <router-link to="/mentionslegales">
                    <a class="nav-link" style="color: white">
                      Mentions légales
                    </a>
                  </router-link>
                </li>
                <li>
                  <router-link to="/donneesperso">
                    <a class="nav-link" style="color: white">
                      Politique de données personnelles
                    </a>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          -->
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  name: "app-footer",
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style scoped>
a {
  font-size: xx-small;
}
.footer {
  background-color: #222;
}
a:hover {
  color: red;
}
@media screen and (min-width: 801px) {
  #btm_1 {
    font-size: 1em;
  }
  #btm_2 {
    font-size: 1em;
  }
  #btm_3 {
    font-size: 1em;
  }
  #btm_4 {
    font-size: 1em;
  }
}
@media screen and (max-width: 800px) {
  #btm_1 {
    font-size: 0.75em;
  }
  #btm_2 {
    font-size: 0.75em;
  }
  #btm_3 {
    font-size: 0.75em;
  }
  #btm_4 {
    font-size: 0.75em;
  }
}
@media screen and (max-width: 600px) {
  #btm_1 {
    font-size: 0.6em;
  }
  #btm_2 {
    font-size: 0.6em;
  }
  #btm_3 {
    font-size: 0.6em;
  }
  #btm_4 {
    font-size: 0.6em;
  }
}
@media screen and (max-width: 400px) {
  #btm_1 {
    font-size: 0.5em;
  }
  #btm_2 {
    font-size: 0.5em;
  }
  #btm_3 {
    font-size: 0.5em;
  }
  #btm_4 {
    font-size: 0.5em;
  }
}
</style>
